module.exports = __webpack_public_path__ + "img/短临风险.42466c86.png";